import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { ApiError } from './api/client';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// A 401 from any call means the session is gone — drop the cached user so
// ProtectedRoute sends the app to /login (07-frontend.md §5).
function dropSessionOn401(error: unknown): void {
  if (error instanceof ApiError && error.status === 401) {
    queryClient.setQueryData(['me'], null);
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: dropSessionOn401 }),
  mutationCache: new MutationCache({ onError: dropSessionOn401 }),
});

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
